"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndexRange = void 0;
/**
 * Returns the list of page indices the Pagination component
 * should display. It tries to keep the current page in the
 * center of the list, when possible.
 *
 * @param {number} currentPageIndex - The index of the currently-selected page
 * @param {number} totalPages - The total number of available pages
 * @returns {array}
 */

var getIndexRange = function getIndexRange(currentPageIndex, totalPages, maxNumOfPageButtons) {
  if (maxNumOfPageButtons === void 0) {
    maxNumOfPageButtons = 7;
  }
  var output = [];

  /**
   * Inititally, try to show 3 pages above and below the current page.
   * This helps gravitate towards showing "current" page in the center
   * of 7 page buttons.
   */
  var prevNextCount = Math.floor(maxNumOfPageButtons / 2);

  // Show max of 7 page buttons
  var targetRange = Math.min(maxNumOfPageButtons, totalPages);

  /**
   * Initial guesses
   *
   * Try to set the min page index to 3 below the current.
   * Try to set the max page index to 3 above the current.
   */
  var min = Math.max(0, currentPageIndex - prevNextCount);
  var max = Math.min(currentPageIndex + prevNextCount, totalPages - 1);

  /**
   * Pad the left
   *
   * If min index is not the first page
   * and we still don't have 7 page buttons,
   * decrease the min index so that we show more page buttons.
   */
  if (min > 0 && max - min < targetRange - 1) {
    min -= targetRange - (max - min) - 1;
  }

  /**
   * Pad the right
   *
   * If max index is not the last page
   * and we still don't have 7 page buttons,
   * increase the max index so that we show more page buttons.
   */
  if (max < totalPages - 1 && max - min < targetRange - 1) {
    max += targetRange - (max - min) - 1;
  }

  // Build the final array of page indices
  for (var i = min; i <= max; i += 1) {
    output.push(i);
  }
  return output;
};
exports.getIndexRange = getIndexRange;